import styles from "./styles.module.scss";

function Footer() {
    return (
        <>
            <footer className={styles.footer_container}>
                <div className={styles.footer_1}>
                    <img
                        src="/images/logo.png"
                        className="navbar_logo"
                        width="64px"
                        height="54px"
                    />
                    <div className={styles.footer_1_links}>
                        <div className={styles.footer_heading}>ABOUT</div>
                        <div className={styles.links}>
                            <a href="/equipe" target="_blank">Equipe</a>
                        </div>
                        <div className={styles.links}>
                            <a>carrières</a>
                        </div>
                        <div className={styles.links}>
                            <a>Avantages</a>
                        </div>
                        <div className={styles.links}>
                            <a>Notre histoire</a>
                        </div>
                    </div>
                    <div className={styles.footer_1_links}>
                        <div className={styles.footer_heading}>HELP</div>
                        <div className={styles.links}>
                            <a>FAQs</a>
                        </div>
                        <div className={styles.links}>
                            <a>Cookies</a>
                        </div>
                        <div className={styles.links}>
                            <a>Nous Contacter</a>
                        </div>
                    </div>
                    <div className={styles.footer_1_links}>
                        <div className={styles.footer_heading}>Contact</div>
                        <div className={styles.links}>
                            <img src="/icons/phone.png" alt="icon" className={styles.icon} />
                            <a>&nbsp; +33 782464988</a>
                        </div>
                        <div className={styles.links}>
                            <img src="/icons/location.png" alt="icon" className={styles.icon} />
                            <a>&nbsp; Rue de la mairie 37520 La Riche, France</a>
                        </div>
                    </div>

                </div>
                <div className={styles.footer_2}>
                    <div className={styles.footer_2_links}>
                        <div className={styles.links}>
                            <a href="/mentions_legales" target="_blank">Mentions legales</a>
                        </div>
                        <div className={styles.links}>
                            <a href="/politique_de_confidentialite" target="_blank">politique de confidentialité</a>
                        </div>
                    </div>
                    <div className={styles.copy_right}>
                        <span>Copyright &copy; 2022 Tous droits réservés par OrgaExpert</span>
                    </div>
                    <div className={styles.footer_icons}>
                        <div className={styles.icon} >
                            <a href="https://www.facebook.com/Orgaexpert-690070915199722" target="_blank">
                                <img src="/icons/facebook.png" alt="icon" />
                            </a>
                        </div>
                        <div className={styles.icon} >
                            <img src="/icons/twitter.png" alt="icon" />
                        </div>
                        <div className={styles.icon} >
                            <a href="https://www.instagram.com/orgaexpert.fr/" target="_blank">
                                <img src="/icons/instagram.png" alt="icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;